import { createRouter, createWebHistory } from 'vue-router'
import TestPage from '@/views/TestPage.vue'
import LoginView from '@/views/Login.vue'
import RegisterView from '@/views/Register.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'
import PasswordReset from '@/views/password-reset/PasswordReset.vue'
import PasswordResetEmailSend from '@/views/password-reset/PasswordResetEmailSend.vue'
import PasswordResetNewPassword from '@/views/password-reset/PasswordResetNewPassword.vue'
import PasswordResetSuccess from '@/views/password-reset/PasswordResetSuccess.vue'
import NotFound from '@/views/404.vue'

export const ROUTE_NAMES = {
  NO_FOUND: '404_VIEW',
  TEST: 'TEST_VIEW',
  // auth
  LOGIN: 'LOGIN_VIEW',
  REGISTER: 'REGISTER_VIEW',
  // Email verification
  VERIFY_EMAIL: 'VERIFY_EMAIL_VIEW',
  // Password reset
  PASSWORD_RESET: 'PASSWORD_RESET_VIEW',
  PASSWORD_RESET_EMAIL_SEND: 'PASSWORD_RESET_EMAIL_SEND_VIEW',
  PASSWORD_RESET_SUCCESS: 'PASSWORD_RESET_SUCCESS_VIEW',
  PASSWORD_RESET_NEW_PASSWORD: 'PASSWORD_RESET_NEW_PASSWORD_VIEW'
}

const routes = [
  // auth
  {
    path: '/',
    name: ROUTE_NAMES.LOGIN,
    component: LoginView
  },
  {
    path: '/register',
    name: ROUTE_NAMES.REGISTER,
    component: RegisterView
  },
  // Email verification
  {
    path: '/auth/confirm-email/:confirmationCode',
    name: ROUTE_NAMES.VERIFY_EMAIL,
    component: VerifyEmail
  },
  // Password reset
  {
    path: '/password-reset',
    name: ROUTE_NAMES.PASSWORD_RESET,
    component: PasswordReset
  },
  {
    path: '/password-reset-email-send',
    name: ROUTE_NAMES.PASSWORD_RESET_EMAIL_SEND,
    component: PasswordResetEmailSend
  },
  {
    path: '/auth/reset-verify/:code',
    // path: '/password-reset-set-new-password',
    name: ROUTE_NAMES.PASSWORD_RESET_NEW_PASSWORD,
    component: PasswordResetNewPassword
  },
  {
    path: '/password-reset-success',
    name: ROUTE_NAMES.PASSWORD_RESET_SUCCESS,
    component: PasswordResetSuccess
  },
  {
    path: '/:pathMatch(.*)*',
    component: NotFound
    // redirect: to => ({name: ROUTE_NAMES.})
  }
]

// debug and test view - DEV ONLY !!!
// if (import.meta.env.MODE === 'development') {
routes.push({
  path: '/handle-login',
  name: ROUTE_NAMES.TEST,
  component: TestPage
})
// }

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes
})

export default router
